import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "../Reveal";
import { FAQS } from "../../lib/site";

export const Faq = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="py-16 sm:py-24 lg:py-32 px-4 sm:px-8 lg:px-12 bg-[#070D24] border-y border-white/5 scroll-mt-20"
  >
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
      <Reveal className="lg:col-span-4 space-y-4">
        <Eyebrow>Questions, Answered</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
          Everything You're <span className="gradient-accent-text">Wondering</span>
        </h2>
        <p className="text-base text-slate-300">
          Straight answers about pricing, timelines, budgets and reporting. Still
          unsure? Ask us directly on the free call.
        </p>
      </Reveal>
      <Reveal className="lg:col-span-8" delay={0.15}>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="glass-card rounded-2xl border-white/10 px-6 overflow-hidden"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display font-semibold text-white text-sm sm:text-base hover:no-underline hover:text-cyan-300 py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-300 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
